import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, vModelText as _vModelText, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[9999] overflow-hidden"
}
const _hoisted_2 = { class: "relative flex h-full items-center justify-center p-3 pointer-events-none" }
const _hoisted_3 = { class: "shrink-0 p-5 border-b border-gray-200 flex items-start justify-between gap-4" }
const _hoisted_4 = { class: "text-sm text-gray-600 mt-1" }
const _hoisted_5 = {
  class: "shrink-0 min-h-[52px] border-b border-gray-200 px-5 flex gap-1 overflow-x-auto",
  role: "tablist",
  "aria-label": "Configuration PrestaShop"
}
const _hoisted_6 = ["disabled", "aria-selected", "onClick"]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = {
  key: 1,
  class: "max-w-xl space-y-4"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "space-y-4 rounded-lg border border-gray-200 p-4" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "text-xs text-amber-700"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "text-xs text-amber-700"
}
const _hoisted_17 = {
  key: 1,
  class: "text-xs text-amber-700"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 2,
  class: "max-w-xl space-y-4"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "space-y-2" }
const _hoisted_24 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_25 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "font-medium" }
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = {
  key: 3,
  class: "space-y-5"
}
const _hoisted_30 = { class: "flex flex-wrap items-center justify-between gap-2 text-xs text-gray-500" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "text-sm text-gray-500",
  role: "status"
}
const _hoisted_33 = {
  key: 1,
  class: "text-sm text-blue-700"
}
const _hoisted_34 = {
  key: 2,
  class: "rounded-lg bg-amber-50 p-3 text-xs text-amber-800"
}
const _hoisted_35 = { class: "space-y-2" }
const _hoisted_36 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_37 = {
  key: 0,
  class: "text-sm text-green-700"
}
const _hoisted_38 = { class: "flex items-center gap-2 text-sm font-medium text-gray-900" }
const _hoisted_39 = ["title", "aria-label"]
const _hoisted_40 = {
  key: 1,
  class: "text-xs font-normal text-gray-500"
}
const _hoisted_41 = {
  key: 2,
  class: "text-xs font-normal text-gray-600"
}
const _hoisted_42 = ["disabled", "onClick"]
const _hoisted_43 = { class: "space-y-2" }
const _hoisted_44 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_45 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_46 = { class: "text-sm min-w-0" }
const _hoisted_47 = { class: "font-medium" }
const _hoisted_48 = { class: "flex items-center gap-3" }
const _hoisted_49 = ["disabled", "onClick"]
const _hoisted_50 = ["disabled", "onClick"]
const _hoisted_51 = { class: "border-t border-gray-100 pt-3" }
const _hoisted_52 = {
  key: 0,
  class: "mt-3 flex flex-wrap gap-2"
}
const _hoisted_53 = ["disabled"]
const _hoisted_54 = {
  key: 0,
  class: "fixed inset-0 z-[10050] flex items-center justify-center p-3"
}
const _hoisted_55 = { class: "relative flex max-h-[85vh] w-full max-w-xl flex-col rounded-xl bg-white p-5 shadow-xl" }
const _hoisted_56 = { class: "flex items-start justify-between gap-4" }
const _hoisted_57 = { class: "font-semibold text-gray-900" }
const _hoisted_58 = { class: "text-sm text-gray-600 mt-1" }
const _hoisted_59 = {
  key: 0,
  class: "mt-3 rounded-lg bg-red-50 p-2 text-sm text-red-700"
}
const _hoisted_60 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_61 = {
  key: 2,
  class: "mt-5 flex min-h-0 flex-col gap-3"
}
const _hoisted_62 = { class: "min-h-0 overflow-y-auto rounded-lg border border-gray-200" }
const _hoisted_63 = ["disabled", "onClick"]
const _hoisted_64 = {
  key: 0,
  class: "p-3 text-sm text-gray-500"
}
const _hoisted_65 = {
  key: 3,
  class: "mt-5 min-h-0 overflow-y-auto space-y-3"
}
const _hoisted_66 = { class: "rounded-lg border border-gray-200" }
const _hoisted_67 = {
  key: 0,
  class: "border-t border-gray-200 p-3 space-y-2"
}
const _hoisted_68 = { class: "max-h-52 overflow-y-auto" }
const _hoisted_69 = ["disabled", "onClick"]
const _hoisted_70 = { class: "text-xs text-gray-500" }
const _hoisted_71 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_72 = { class: "rounded-lg border border-gray-200" }
const _hoisted_73 = {
  key: 0,
  class: "border-t border-gray-200 p-3 space-y-2"
}
const _hoisted_74 = ["disabled"]

import { computed, onUnmounted, ref, watch } from "vue";
import CouleursPickerModal from "@/components/mel/CouleursPickerModal.vue";
import CategoryTreeAutocomplete from "@/components/forms/CategoryTreeAutocomplete.vue";
import { getCouleursOfficielles } from "@/api/couleurs";
import { getCategoriesTree } from "@/api/categories";
import { getReferenceData } from "@/api/shooting";
import {
  createPrestashopBrandMapping,
  deletePrestashopMapping,
  ensurePrestashopUnitDefaults,
  getPrestashopMappingTargets,
  getPrestashopMappings,
  getPrestashopPendingMappings,
  getPrestashopSettings,
  getPrestashopProvenances,
  getPrestashopCategoryWeights,
  savePrestashopCategoryWeight,
  deletePrestashopCategoryWeight,
  savePrestashopMapping,
  savePrestashopSettings,
  type PrestashopCategoryWeight,
  type PrestashopMapping,
  type PrestashopMappingTarget,
  type PrestashopMappingType,
  type PrestashopPendingMappings,
  type PrestashopSettings,
} from "@/api/prestashop";
import {
  formatDeclinaisonLabel,
  getDeclinaisonLength,
} from "@/utils/declinaisonLabel";
import type { PrestashopReferenceOption } from "@/types/prestashop";
import type { CouleurAPI } from "@/types/mel-components";
import type { CategorieNode, CategoryPathSelection } from "@/types/categorie";

type Tab = "general" | "weight" | PrestashopMappingType;

export default /*@__PURE__*/_defineComponent({
  __name: 'PrestashopConfigurationModal',
  props: {
    visible: { type: Boolean },
    shopUrl: {},
    requiredSetup: { type: Boolean },
    catalogReady: { type: Boolean },
    catalogRevision: {},
    pendingColors: {},
    pendingCategories: {},
    pendingCompositions: {},
    pendingBrands: {}
  },
  emits: ["update:visible", "changed", "settings-saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const tabs: Array<{ id: Tab; label: string }> = [
  { id: "general", label: "Général" },
  { id: "color", label: "Couleurs" },
  { id: "category", label: "Catégories" },
  { id: "composition", label: "Compositions" },
  { id: "weight", label: "Poids" },
  { id: "brand", label: "Marques" },
];
const tab = ref<Tab>("general");
const defaultGender = ref<
  "" | NonNullable<PrestashopSettings["defaultGender"]>
>("");
const savedGender = ref<PrestashopSettings["defaultGender"]>(null);
const priceAdjustmentPercent = ref(0);
const priceIsUnit = ref(true);
const weightIsUnit = ref(true);
const defaultProvenanceId = ref<number | "">("");
const defaultSoldBy = ref<"" | NonNullable<PrestashopSettings["defaultSoldBy"]>>(
  ""
);
const savedProvenanceId = ref<number | null>(null);
const defaultDeclinaisonId = ref<number | "">("");
const defaultPackId = ref<number | "">("");
const declinaisons = ref<PrestashopReferenceOption[]>([]);
const packs = ref<PrestashopReferenceOption[]>([]);
const provenances = ref<Array<{ id: number; label: string }>>([]);
const mappings = ref<PrestashopMapping[]>([]);
const targets = ref<PrestashopMappingTarget[]>([]);
const pendingSummary = ref<PrestashopPendingMappings | null>(null);
const pendingLoading = ref(false);
const loading = ref(false);
const busy = ref(false);
const message = ref("");
const messageIsError = ref(false);
const pickerVisible = ref(false);
const colorPickerVisible = ref(false);
const pickerSource = ref("");
const pickerSearch = ref("");
const brandName = ref("");
const brandListOpen = ref(true);
const brandCreateOpen = ref(false);
const manualOpen = ref(false);
const manualSource = ref("");
const officialColors = ref<CouleurAPI[]>([]);
const categoriesTree = ref<CategorieNode[]>([]);
const categoryWeights = ref<PrestashopCategoryWeight[]>([]);
const weightCategoryId = ref<number | "">("");
const weightCategoryLabel = ref("");
const categoryWeightInput = ref("");
const weightFormKey = ref(0);
let loadSequence = 0;
let pendingSequence = 0;
const resolvedDuringScan = new Map<PrestashopMappingType, Set<string>>();

const pendingByType = computed(
  () =>
    pendingSummary.value || {
      color: props.pendingColors,
      category: props.pendingCategories,
      composition: props.pendingCompositions,
      brand: props.pendingBrands,
      colorHexByName: {},
      categorySources: [],
      scannedProducts: 0,
      incomplete: false,
    }
);
const pending = computed(() =>
  tab.value === "general" || tab.value === "weight"
    ? []
    : pendingByType.value[tab.value]
);
const pendingRows = computed(() => {
  if (
    tab.value === "category" &&
    pendingSummary.value?.categorySources?.length
  ) {
    return pendingSummary.value.categorySources.map((row) => ({
      label: row.sourceLabel,
      sourceId: row.sourceId,
    }));
  }
  return pending.value.map((label) => ({
    label,
    sourceId: null as number | null,
  }));
});
const chooseLabel = computed(() =>
  tab.value === "color"
    ? "Choisir une couleur"
    : tab.value === "category"
    ? "Choisir une catégorie"
    : tab.value === "composition"
    ? "Choisir une matière"
    : "Choisir une marque"
);
const filteredTargets = computed(() => {
  const search = normalize(pickerSearch.value);
  const rows = search
    ? targets.value.filter((target) => normalize(target.label).includes(search))
    : targets.value;
  if (tab.value !== "brand" || search) return rows;
  const source = normalize(pickerSource.value);
  const sourceWords = new Set(
    source.split(" ").filter((word) => word.length > 2 && word !== "b2b")
  );
  return [...rows].sort((left, right) => {
    const score = (target: PrestashopMappingTarget) =>
      normalize(target.label)
        .split(" ")
        .filter((word) => sourceWords.has(word)).length +
      (normalize(target.label) === source ? 10 : 0);
    return (
      score(right) - score(left) ||
      Number(right.isDefault) - Number(left.isDefault) ||
      left.label.localeCompare(right.label, "fr")
    );
  });
});

function optionSizeCount(value: string | number | undefined | null) {
  return String(value || "")
    .split(",")
    .map((part) => part.trim())
    .filter((part) => part !== "").length;
}

function declinaisonSizeCount(
  declinaison: PrestashopReferenceOption | undefined
) {
  if (!declinaison) return 0;
  return (
    getDeclinaisonLength(declinaison.tailles) ||
    optionSizeCount(declinaison.tailles)
  );
}

function declinaisonOptionLabel(declinaison: PrestashopReferenceOption) {
  return (
    formatDeclinaisonLabel(declinaison.label, declinaison.tailles) ||
    String(declinaison.id)
  );
}

function packOptionLabel(pack: PrestashopReferenceOption) {
  const label = String(pack.label || pack.id);
  const value = String(pack.value ?? "").trim();
  if (!value || label.includes(`(${value})`)) return label;
  return `${label} (${value})`;
}

function packSizeCount(pack: PrestashopReferenceOption) {
  return optionSizeCount(pack.value);
}

function packOptionDisabled(pack: PrestashopReferenceOption) {
  const declinaison = declinaisons.value.find(
    (item) => Number(item.id) === Number(defaultDeclinaisonId.value)
  );
  const expected = declinaisonSizeCount(declinaison);
  if (!expected) return true;
  return packSizeCount(pack) !== expected;
}

const packsForDefaultDeclinaison = computed(() =>
  packs.value.filter((pack) => !packOptionDisabled(pack))
);

async function createUnitDefaults() {
  if (busy.value) return;
  busy.value = true;
  try {
    const defaults = await ensurePrestashopUnitDefaults();
    const references = await getReferenceData();
    declinaisons.value = references.declinaisons || [];
    packs.value = references.packs || [];
    defaultDeclinaisonId.value = defaults.defaultDeclinaisonId;
    defaultPackId.value = defaults.defaultPackId;
    showMessage("Déclinaison TU et pack unitaire prêts.");
  } catch (caught) {
    showMessage(
      caught instanceof Error ? caught.message : "Création impossible.",
      true
    );
  } finally {
    busy.value = false;
  }
}

function normalize(value: string) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}
function pendingCount(type: Tab) {
  if (type === "general" || type === "weight") return 0;
  return pendingByType.value[type].length;
}
function colorHex(label: string): string | null {
  const hex = pendingByType.value.colorHexByName[normalize(label)];
  return /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(hex || "") ? hex : null;
}
function clearPending(type: PrestashopMappingType, source: string) {
  if (pendingLoading.value) {
    const resolved = resolvedDuringScan.get(type) || new Set<string>();
    resolved.add(normalize(source));
    resolvedDuringScan.set(type, resolved);
  }
  if (pendingSummary.value) {
    pendingSummary.value = {
      ...pendingSummary.value,
      [type]: pendingSummary.value[type].filter(
        (label) => normalize(label) !== normalize(source)
      ),
      ...(type === "category"
        ? {
            categorySources: pendingSummary.value.categorySources.filter(
              (row) => normalize(row.sourceLabel) !== normalize(source)
            ),
          }
        : {}),
    };
  }
}
function showMessage(value: string, isError = false) {
  message.value = value;
  messageIsError.value = isError;
}
function close() {
  if (props.requiredSetup) return;
  emit("update:visible", false);
}
const panel = ref<HTMLElement | null>(null);
const scrollBody = ref<HTMLElement | null>(null);

function scrollPastControls(event: WheelEvent) {
  const scroller = scrollBody.value;
  const target = event.target;
  if (!scroller || !(target instanceof Element)) return;
  const overSelect = Boolean(target.closest("select"));
  const overTabs = Boolean(target.closest("[role='tablist']"));
  if (!overSelect && !overTabs) return;
  if (overTabs && Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
  const maxScroll = scroller.scrollHeight - scroller.clientHeight;
  if (maxScroll <= 0) return;
  const delta =
    event.deltaMode === 1
      ? event.deltaY * 16
      : event.deltaMode === 2
        ? event.deltaY * scroller.clientHeight
        : event.deltaY;
  const next = Math.min(maxScroll, Math.max(0, scroller.scrollTop + delta));
  if (next === scroller.scrollTop) return;
  scroller.scrollTop = next;
  event.preventDefault();
}

function onEscape(event: KeyboardEvent) {
  if (event.key !== "Escape") return;
  if (colorPickerVisible.value) {
    colorPickerVisible.value = false;
    return;
  }
  if (pickerVisible.value) {
    pickerVisible.value = false;
    return;
  }
  close();
}

watch(panel, (element, previous) => {
  previous?.removeEventListener("wheel", scrollPastControls);
  element?.addEventListener("wheel", scrollPastControls, { passive: false });
});
watch(
  () => props.visible,
  (visible) => {
    if (visible) window.addEventListener("keydown", onEscape);
    else window.removeEventListener("keydown", onEscape);
  },
);
onUnmounted(() => {
  panel.value?.removeEventListener("wheel", scrollPastControls);
  window.removeEventListener("keydown", onEscape);
});
async function loadPending(force = false) {
  if (!props.catalogReady) return;
  if ((pendingLoading.value || pendingSummary.value) && !force) return;
  const sequence = ++pendingSequence;
  resolvedDuringScan.clear();
  pendingLoading.value = true;
  try {
    const summary = await getPrestashopPendingMappings();
    if (sequence === pendingSequence) {
      for (const type of [
        "color",
        "category",
        "composition",
        "brand",
      ] as const) {
        const resolved = resolvedDuringScan.get(type);
        if (resolved)
          summary[type] = summary[type].filter(
            (label) => !resolved.has(normalize(label))
          );
        if (type === "category" && resolved) {
          summary.categorySources = summary.categorySources.filter(
            (row) => !resolved.has(normalize(row.sourceLabel))
          );
        }
      }
      pendingSummary.value = summary;
    }
  } catch (caught) {
    if (sequence === pendingSequence)
      showMessage(
        caught instanceof Error
          ? caught.message
          : "Catalogue PrestaShop indisponible.",
        true
      );
  } finally {
    if (sequence === pendingSequence) {
      pendingLoading.value = false;
      resolvedDuringScan.clear();
    }
  }
}
async function loadTab(type: PrestashopMappingType) {
  const sequence = ++loadSequence;
  loading.value = true;
  try {
    const [nextMappings, nextTargets] = await Promise.all([
      getPrestashopMappings(type),
      getPrestashopMappingTargets(type),
    ]);
    if (sequence === loadSequence) {
      mappings.value = nextMappings;
      targets.value = nextTargets;
    }
  } catch (caught) {
    if (sequence === loadSequence)
      showMessage(
        caught instanceof Error ? caught.message : "Chargement impossible.",
        true
      );
  } finally {
    if (sequence === loadSequence) loading.value = false;
  }
}
function selectTab(value: Tab) {
  if (busy.value || (props.requiredSetup && value !== "general")) return;
  tab.value = value;
  pickerVisible.value = false;
  colorPickerVisible.value = false;
  showMessage("");
  if (value === "general") {
    loadSequence += 1;
    loading.value = false;
  } else if (value === "weight") {
    void loadWeightTab();
  } else void loadTab(value);
}

function formatCategoryWeight(weight: number) {
  return String(weight).replace(".", ",");
}

function onWeightCategorySelect(path: CategoryPathSelection) {
  weightCategoryId.value = Number(path.leafId) || "";
  weightCategoryLabel.value = path.pathLabel;
}

async function loadWeightTab() {
  const sequence = ++loadSequence;
  loading.value = true;
  try {
    const [rows, tree] = await Promise.all([
      getPrestashopCategoryWeights(),
      categoriesTree.value.length
        ? Promise.resolve(categoriesTree.value)
        : getCategoriesTree(),
    ]);
    if (sequence !== loadSequence) return;
    categoryWeights.value = rows;
    categoriesTree.value = tree;
  } catch (caught) {
    if (sequence === loadSequence)
      showMessage(
        caught instanceof Error ? caught.message : "Chargement impossible.",
        true
      );
  } finally {
    if (sequence === loadSequence) loading.value = false;
  }
}

async function saveCategoryWeightRule() {
  const categoryId = Number(weightCategoryId.value);
  const weightKg = Number(String(categoryWeightInput.value).replace(",", "."));
  if (!categoryId || !Number.isFinite(weightKg) || weightKg <= 0 || busy.value)
    return;
  busy.value = true;
  try {
    categoryWeights.value = await savePrestashopCategoryWeight(
      categoryId,
      weightKg
    );
    weightCategoryId.value = "";
    weightCategoryLabel.value = "";
    categoryWeightInput.value = "";
    weightFormKey.value += 1;
    emit("changed");
    showMessage(
      "Poids de catégorie enregistré. Le poids PrestaShop de ces produits est ignoré."
    );
  } catch (caught) {
    showMessage(
      caught instanceof Error ? caught.message : "Enregistrement impossible.",
      true
    );
  } finally {
    busy.value = false;
  }
}

async function removeCategoryWeightRule(categoryId: number) {
  if (busy.value) return;
  busy.value = true;
  try {
    categoryWeights.value = await deletePrestashopCategoryWeight(categoryId);
    emit("changed");
    showMessage("Règle de poids supprimée.");
  } catch (caught) {
    showMessage(
      caught instanceof Error ? caught.message : "Suppression impossible.",
      true
    );
  } finally {
    busy.value = false;
  }
}
async function saveGeneral() {
  if (
    !defaultGender.value ||
    !defaultProvenanceId.value ||
    !defaultSoldBy.value ||
    !defaultDeclinaisonId.value ||
    !defaultPackId.value ||
    busy.value
  )
    return;
  busy.value = true;
  try {
    const settings = await savePrestashopSettings(
      defaultGender.value,
      Number(defaultProvenanceId.value),
      priceAdjustmentPercent.value,
      priceIsUnit.value,
      weightIsUnit.value,
      defaultDeclinaisonId.value ? Number(defaultDeclinaisonId.value) : null,
      defaultPackId.value ? Number(defaultPackId.value) : null,
      defaultSoldBy.value
    );
    const settingChanged =
      savedGender.value !== settings.defaultGender ||
      savedProvenanceId.value !== settings.defaultProvenanceId;
    savedGender.value = settings.defaultGender;
    savedProvenanceId.value = settings.defaultProvenanceId;
    emit("settings-saved", settings);
    emit("changed");
    showMessage("Configuration enregistrée.");
    if (settingChanged) {
      pendingSummary.value = null;
      if (pendingLoading.value) {
        pendingSequence += 1;
        pendingLoading.value = false;
      }
      if (!props.requiredSetup) void loadPending(true);
    }
  } catch (caught) {
    showMessage(
      caught instanceof Error ? caught.message : "Enregistrement impossible.",
      true
    );
  } finally {
    busy.value = false;
  }
}
async function openPicker(source: string) {
  if (
    tab.value === "general" ||
    busy.value ||
    loading.value
  )
    return;
  busy.value = true;
  pickerSource.value = source;
  pickerSearch.value = "";
  brandName.value = source;
  brandListOpen.value = true;
  brandCreateOpen.value = false;
  try {
    if (tab.value === "color") {
      if (!officialColors.value.length)
        officialColors.value = await getCouleursOfficielles();
      colorPickerVisible.value = true;
    } else {
      if (tab.value === "category" && !categoriesTree.value.length)
        categoriesTree.value = await getCategoriesTree();
      pickerVisible.value = true;
    }
  } catch (caught) {
    showMessage(
      caught instanceof Error ? caught.message : "Sélecteur indisponible.",
      true
    );
  } finally {
    busy.value = false;
  }
}
async function savePickedTarget(targetId: number) {
  if (tab.value === "general" || busy.value || !pickerSource.value) return;
  busy.value = true;
  try {
    await savePrestashopMapping(tab.value, pickerSource.value, targetId);
    clearPending(tab.value, pickerSource.value);
    pickerVisible.value = false;
    colorPickerVisible.value = false;
    manualSource.value = "";
    await loadTab(tab.value);
    emit("changed");
    showMessage("Correspondance enregistrée.");
  } catch (caught) {
    showMessage(
      caught instanceof Error ? caught.message : "Enregistrement impossible.",
      true
    );
  } finally {
    busy.value = false;
  }
}
function onColorConfirm(colors: CouleurAPI[]) {
  const color = colors[0];
  colorPickerVisible.value = false;
  if (color) void savePickedTarget(color.id_couleur);
}
function onCategorySelect(path: CategoryPathSelection) {
  const targetId = Number(path.leafId);
  if (targetId) void savePickedTarget(targetId);
}
async function createBrand() {
  if (tab.value !== "brand" || busy.value || !brandName.value) return;
  busy.value = true;
  try {
    const result = await createPrestashopBrandMapping(
      pickerSource.value,
      brandName.value
    );
    clearPending("brand", pickerSource.value);
    pickerVisible.value = false;
    manualSource.value = "";
    await loadTab("brand");
    emit("changed");
    showMessage(
      result.createdBrand ? "Marque créée et liée." : "Marque existante liée."
    );
  } catch (caught) {
    showMessage(
      caught instanceof Error ? caught.message : "Création impossible.",
      true
    );
  } finally {
    busy.value = false;
  }
}
async function remove(row: PrestashopMapping) {
  if (tab.value === "general" || busy.value) return;
  busy.value = true;
  try {
    await deletePrestashopMapping(tab.value, row.sourceLabel);
    await loadTab(tab.value);
    if (pendingLoading.value) {
      pendingSequence += 1;
      pendingLoading.value = false;
    }
    void loadPending(true);
    emit("changed");
    showMessage("Correspondance supprimée.");
  } catch (caught) {
    showMessage(
      caught instanceof Error ? caught.message : "Suppression impossible.",
      true
    );
  } finally {
    busy.value = false;
  }
}

watch(
  () => props.visible,
  async (visible) => {
    if (!visible) return;
    tab.value = "general";
    loadSequence += 1;
    loading.value = false;
    showMessage("");
    try {
      const [settings, provenanceOptions, references] = await Promise.all([
        getPrestashopSettings(),
        getPrestashopProvenances(),
        getReferenceData(),
      ]);
      provenances.value = provenanceOptions;
      declinaisons.value = references.declinaisons || [];
      packs.value = references.packs || [];
      defaultGender.value = settings.defaultGender || "";
      savedGender.value = settings.defaultGender;
      priceAdjustmentPercent.value = [0, 5, 10].includes(
        Number(settings.priceAdjustmentPercent)
      )
        ? Number(settings.priceAdjustmentPercent)
        : 0;
      priceIsUnit.value = Boolean(settings.priceIsUnit);
      weightIsUnit.value = Boolean(settings.weightIsUnit);
      defaultProvenanceId.value = provenanceOptions.some(
        (option) => option.id === settings.defaultProvenanceId
      )
        ? Number(settings.defaultProvenanceId)
        : "";
      savedProvenanceId.value = settings.defaultProvenanceId;
      defaultSoldBy.value =
        settings.defaultSoldBy === "couleurs" ||
        settings.defaultSoldBy === "melangees" ||
        settings.defaultSoldBy === "tailles"
          ? settings.defaultSoldBy
          : "";
      defaultDeclinaisonId.value = declinaisons.value.some(
        (option) => Number(option.id) === Number(settings.defaultDeclinaisonId)
      )
        ? Number(settings.defaultDeclinaisonId)
        : "";
      defaultPackId.value = packs.value.some(
        (option) =>
          Number(option.id) === Number(settings.defaultPackId) &&
          !packOptionDisabled(option)
      )
        ? Number(settings.defaultPackId)
        : "";
      if (!props.requiredSetup) void loadPending();
    } catch (caught) {
      showMessage(
        caught instanceof Error
          ? caught.message
          : "Configuration indisponible.",
        true
      );
    }
  }
);
watch(
  () => props.shopUrl,
  () => {
    pendingSequence += 1;
    pendingSummary.value = null;
    pendingLoading.value = false;
    resolvedDuringScan.clear();
  }
);
watch(
  () => props.catalogRevision,
  () => {
    pendingSummary.value = null;
    if (props.visible && !props.requiredSetup) void loadPending(true);
  }
);
watch(defaultDeclinaisonId, () => {
  if (
    packsForDefaultDeclinaison.value.some(
      (pack) => Number(pack.id) === Number(defaultPackId.value)
    )
  )
    return;
  defaultPackId.value = "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.requiredSetup)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "absolute inset-0 bg-black/50",
                  "aria-label": "Fermer la configuration PrestaShop",
                  onClick: close
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                ref_key: "panel",
                ref: panel,
                class: "pointer-events-auto relative bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[calc(100dvh-1.5rem)] min-h-0 flex flex-col overflow-hidden",
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "prestashop-configuration-title"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _cache[21] || (_cache[21] = _createElementVNode("h2", {
                      id: "prestashop-configuration-title",
                      class: "text-lg font-semibold text-black"
                    }, " Configuration PrestaShop ", -1)),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.requiredSetup
                  ? "Choisissez le genre, le pays de provenance et le type de vente avant le premier import."
                  : "Associez une fois les libellés PrestaShop à vos valeurs eFashion."), 1)
                  ]),
                  (!_ctx.requiredSetup)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "relative z-10 shrink-0 rounded-md p-2 text-gray-500 hover:bg-gray-100",
                        "aria-label": "Fermer",
                        onClick: close
                      }, _cache[22] || (_cache[22] = [
                        _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (item) => {
                    return _createElementVNode("button", {
                      key: item.id,
                      type: "button",
                      role: "tab",
                      class: _normalizeClass(["shrink-0 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 flex items-center gap-1.5", 
              tab.value === item.id
                ? 'border-green-600 text-green-700'
                : 'border-transparent text-gray-600'
            ]),
                      disabled: busy.value || (_ctx.requiredSetup && item.id !== 'general'),
                      "aria-selected": tab.value === item.id,
                      onClick: ($event: any) => (selectTab(item.id))
                    }, [
                      _createTextVNode(_toDisplayString(item.label) + " ", 1),
                      (item.id !== 'general' && pendingCount(item.id))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "inline-flex items-center gap-1 text-red-600",
                            "aria-label": pendingCount(item.id) + ' correspondances à traiter'
                          }, [
                            _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-exclamation-circle text-xs" }, null, -1)),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(pendingCount(item.id)), 1)
                          ], 8, _hoisted_7))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_6)
                  }), 64))
                ]),
                _createElementVNode("div", {
                  ref_key: "scrollBody",
                  ref: scrollBody,
                  class: "min-h-0 flex-1 overflow-y-auto overscroll-contain p-5 space-y-4"
                }, [
                  (message.value)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(["text-sm rounded-lg p-3", 
              messageIsError.value
                ? 'bg-red-50 text-red-700'
                : 'bg-green-50 text-green-700'
            ])
                      }, _toDisplayString(message.value), 3))
                    : _createCommentVNode("", true),
                  (tab.value === 'general')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[34] || (_cache[34] = _createElementVNode("label", {
                          class: "block text-sm font-medium text-gray-800",
                          for: "prestashop-default-gender"
                        }, "Genre par défaut", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "prestashop-default-gender",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((defaultGender).value = $event)),
                          class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                        }, _cache[24] || (_cache[24] = [
                          _createElementVNode("option", { value: "" }, "Choisir un genre", -1),
                          _createElementVNode("option", { value: "femme" }, "Femme", -1),
                          _createElementVNode("option", { value: "homme" }, "Homme", -1),
                          _createElementVNode("option", { value: "enfant" }, "Enfant", -1),
                          _createElementVNode("option", { value: "aucun" }, " Plusieurs genres / aucun genre par défaut ", -1)
                        ]), 512), [
                          [_vModelSelect, defaultGender.value]
                        ]),
                        _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-xs text-gray-600" }, " Cette préférence aide à proposer une catégorie. Les catégories ambiguës restent à valider. ", -1)),
                        _cache[36] || (_cache[36] = _createElementVNode("label", {
                          class: "block text-sm font-medium text-gray-800",
                          for: "prestashop-default-provenance"
                        }, "Pays de provenance par défaut", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "prestashop-default-provenance",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((defaultProvenanceId).value = $event)),
                          class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                        }, [
                          _cache[25] || (_cache[25] = _createElementVNode("option", { value: "" }, "Choisir un pays", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provenances.value, (provenance) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: provenance.id,
                              value: provenance.id
                            }, _toDisplayString(provenance.label), 9, _hoisted_10))
                          }), 128))
                        ], 512), [
                          [
                            _vModelSelect,
                            defaultProvenanceId.value,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-xs text-gray-600" }, " Ce pays est utilisé seulement si PrestaShop ne renseigne pas une provenance reconnue pour le produit. ", -1)),
                        _cache[38] || (_cache[38] = _createElementVNode("label", {
                          class: "block text-sm font-medium text-gray-800",
                          for: "prestashop-default-sold-by"
                        }, "Type de vente par défaut", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "prestashop-default-sold-by",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((defaultSoldBy).value = $event)),
                          class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                        }, _cache[26] || (_cache[26] = [
                          _createElementVNode("option", { value: "" }, "Choisir un type de vente", -1),
                          _createElementVNode("option", { value: "couleurs" }, "À la couleur", -1),
                          _createElementVNode("option", { value: "melangees" }, "Couleurs mélangées", -1),
                          _createElementVNode("option", { value: "tailles" }, "Tailles aux choix", -1)
                        ]), 512), [
                          [_vModelSelect, defaultSoldBy.value]
                        ]),
                        _cache[39] || (_cache[39] = _createElementVNode("p", { class: "text-xs text-gray-600" }, " Ce choix est mis sur les fiches seulement si PrestaShop n’écrit pas explicitement couleurs, couleurs mélangées ou tailles. ", -1)),
                        _createElementVNode("div", _hoisted_11, [
                          _cache[30] || (_cache[30] = _createElementVNode("div", null, [
                            _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, " Si non trouvé "),
                            _createElementVNode("p", { class: "text-xs text-gray-600" }, " Taille et quantité de paquet de ce vendeur. Elles sont utilisées seulement quand PrestaShop n’en fournit pas déjà une reconnue. ")
                          ], -1)),
                          _cache[31] || (_cache[31] = _createElementVNode("label", {
                            class: "block text-sm font-medium text-gray-800",
                            for: "prestashop-default-declinaison"
                          }, "Taille du paquet", -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "prestashop-default-declinaison",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((defaultDeclinaisonId).value = $event)),
                            class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                          }, [
                            _cache[27] || (_cache[27] = _createElementVNode("option", { value: "" }, "Aucune", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(declinaisons.value, (declinaison) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: declinaison.id,
                                value: Number(declinaison.id)
                              }, _toDisplayString(declinaisonOptionLabel(declinaison)), 9, _hoisted_12))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, defaultDeclinaisonId.value]
                          ]),
                          (!declinaisons.value.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Ce vendeur n’a pas encore de taille de paquet. "))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded-lg border border-green-600 px-3 py-2 text-sm font-medium text-green-700 disabled:opacity-50",
                            disabled: busy.value,
                            onClick: createUnitDefaults
                          }, " Créer et sélectionner TU · pack 1 ", 8, _hoisted_14),
                          (defaultDeclinaisonId.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[29] || (_cache[29] = _createElementVNode("label", {
                                  class: "block text-sm font-medium text-gray-800",
                                  for: "prestashop-default-pack"
                                }, "Quantité du paquet", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  id: "prestashop-default-pack",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((defaultPackId).value = $event)),
                                  class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                                }, [
                                  _cache[28] || (_cache[28] = _createElementVNode("option", { value: "" }, "Aucune", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packsForDefaultDeclinaison.value, (pack) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: pack.id,
                                      value: Number(pack.id)
                                    }, _toDisplayString(packOptionLabel(pack)), 9, _hoisted_15))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, defaultPackId.value]
                                ]),
                                (!packs.value.length)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Ce vendeur n’a pas encore de quantité de paquet. "))
                                  : (!packsForDefaultDeclinaison.value.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Aucune quantité ne correspond à cette taille de paquet. "))
                                    : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[40] || (_cache[40] = _createElementVNode("label", {
                          class: "block text-sm font-medium text-gray-800",
                          for: "prestashop-price-adjustment"
                        }, "Coefficient de prix", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "prestashop-price-adjustment",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((priceAdjustmentPercent).value = $event)),
                          class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                        }, _cache[32] || (_cache[32] = [
                          _createElementVNode("option", { value: 0 }, "0 % — prix PrestaShop tel quel", -1),
                          _createElementVNode("option", { value: 5 }, "+5 %", -1),
                          _createElementVNode("option", { value: 10 }, "+10 %", -1)
                        ]), 512), [
                          [
                            _vModelSelect,
                            priceAdjustmentPercent.value,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _cache[41] || (_cache[41] = _createElementVNode("label", {
                          class: "block text-sm font-medium text-gray-800",
                          for: "prestashop-price-is-unit"
                        }, "Le prix PrestaShop est déjà à l’unité", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "prestashop-price-is-unit",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((priceIsUnit).value = $event)),
                          class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                        }, _cache[33] || (_cache[33] = [
                          _createElementVNode("option", { value: false }, " Non — prix du paquet, divisé par la quantité totale ", -1),
                          _createElementVNode("option", { value: true }, "Oui — prix déjà unitaire", -1)
                        ]), 512), [
                          [_vModelSelect, priceIsUnit.value]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-50",
                          disabled: 
                busy.value ||
                !defaultGender.value ||
                !defaultProvenanceId.value ||
                !defaultSoldBy.value ||
                !defaultDeclinaisonId.value ||
                !defaultPackId.value
              ,
                          onClick: saveGeneral
                        }, _toDisplayString(busy.value ? "Enregistrement…" : "Enregistrer la configuration"), 9, _hoisted_18)
                      ]))
                    : (tab.value === 'weight')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", null, [
                            _cache[43] || (_cache[43] = _createElementVNode("label", {
                              class: "block text-sm font-medium text-gray-800",
                              for: "prestashop-weight-is-unit"
                            }, "Le poids PrestaShop est déjà à l’unité", -1)),
                            _withDirectives(_createElementVNode("select", {
                              id: "prestashop-weight-is-unit",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((weightIsUnit).value = $event)),
                              class: "mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                            }, _cache[42] || (_cache[42] = [
                              _createElementVNode("option", { value: false }, " Non — poids du paquet, divisé par la quantité totale ", -1),
                              _createElementVNode("option", { value: true }, "Oui — poids déjà unitaire", -1)
                            ]), 512), [
                              [_vModelSelect, weightIsUnit.value]
                            ]),
                            _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-xs text-gray-600 mt-1" }, " Ce choix s’applique uniquement au poids PrestaShop. Un poids de catégorie est toujours considéré comme un poids unitaire. Si le poids PrestaShop correspond au paquet, il est divisé par la quantité du paquet sur la fiche. Si le poids unitaire reste au-dessus de 5 kg, la fiche reste bloquée. ", -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "mt-3 rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-50",
                              disabled: 
                  busy.value ||
                  !defaultGender.value ||
                  !defaultProvenanceId.value ||
                  !defaultSoldBy.value ||
                  !defaultDeclinaisonId.value ||
                  !defaultPackId.value
                ,
                              onClick: saveGeneral
                            }, _toDisplayString(busy.value ? "Enregistrement…" : "Enregistrer"), 9, _hoisted_20)
                          ]),
                          _cache[47] || (_cache[47] = _createElementVNode("div", null, [
                            _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, " Poids par catégorie "),
                            _createElementVNode("p", { class: "text-xs text-gray-600 mt-1" }, " Chaque produit de la catégorie choisie prend ce poids. Le poids PrestaShop est ignoré. ")
                          ], -1)),
                          (_openBlock(), _createBlock(CategoryTreeAutocomplete, {
                            key: weightFormKey.value,
                            tree: categoriesTree.value,
                            "cat-id": "",
                            "sous-id": "",
                            "sous-sous-id": "",
                            label: "Catégorie",
                            placeholder: "Rechercher une catégorie, par exemple bottes…",
                            onSelect: onWeightCategorySelect
                          }, null, 8, ["tree"])),
                          (weightCategoryLabel.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Catégorie choisie : " + _toDisplayString(weightCategoryLabel.value), 1))
                            : _createCommentVNode("", true),
                          _cache[48] || (_cache[48] = _createElementVNode("label", {
                            class: "block text-sm font-medium text-gray-800",
                            for: "prestashop-category-weight"
                          }, "Poids (kg)", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "prestashop-category-weight",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((categoryWeightInput).value = $event)),
                            type: "number",
                            min: "0.1",
                            step: "0.1",
                            placeholder: "25",
                            class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                          }, null, 512), [
                            [_vModelText, categoryWeightInput.value]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-50",
                            disabled: busy.value || !weightCategoryId.value || !categoryWeightInput.value,
                            onClick: saveCategoryWeightRule
                          }, _toDisplayString(busy.value ? "Enregistrement…" : "Enregistrer ce poids"), 9, _hoisted_22),
                          _createElementVNode("div", _hoisted_23, [
                            _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, " Règles enregistrées ", -1)),
                            (loading.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Chargement… "))
                              : (!categoryWeights.value.length)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, " Aucun poids de catégorie. "))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryWeights.value, (row) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: row.categoryId,
                                class: "flex flex-wrap items-center justify-between gap-3 rounded-lg border border-gray-200 p-3"
                              }, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(row.categoryLabel), 1),
                                  _cache[45] || (_cache[45] = _createElementVNode("span", { class: "mx-2 text-gray-400" }, "→", -1)),
                                  _createElementVNode("span", null, _toDisplayString(formatCategoryWeight(row.weightKg)) + " kg", 1)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "text-sm text-red-700 hover:underline",
                                  disabled: busy.value,
                                  onClick: ($event: any) => (removeCategoryWeightRule(row.categoryId))
                                }, " Supprimer ", 8, _hoisted_28)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _cache[50] || (_cache[50] = _createElementVNode("span", null, "Les correspondances sont calculées depuis le catalogue PrestaShop.", -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-blue-700 hover:underline disabled:opacity-50",
                              disabled: pendingLoading.value || busy.value,
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (loadPending(true)))
                            }, _cache[49] || (_cache[49] = [
                              _createElementVNode("i", { class: "fas fa-sync-alt mr-1" }, null, -1),
                              _createTextVNode(" Recalculer les correspondances ")
                            ]), 8, _hoisted_31)
                          ]),
                          (pendingLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[51] || (_cache[51] = [
                                _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-1" }, null, -1),
                                _createTextVNode(" Analyse du catalogue PrestaShop en cours… ")
                              ])))
                            : _createCommentVNode("", true),
                          (!_ctx.catalogReady)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Les correspondances sont lues directement sur la boutique PrestaShop. "))
                            : _createCommentVNode("", true),
                          (pendingSummary.value?.incomplete)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_34, " Le catalogue est très volumineux : les alertes couvrent les " + _toDisplayString(pendingSummary.value.scannedProducts) + " premiers produits. ", 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("h3", _hoisted_36, " À lier " + _toDisplayString(pending.value.length ? "(" + pending.value.length + ")" : ""), 1),
                            (!pending.value.length && !pendingLoading.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(pendingSummary.value
                    ? "Toutes les valeurs détectées sont liées."
                    : "Aucune correspondance détectée pour le moment."), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingRows.value, (row) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `${row.sourceId || 'label'}-${row.label}`,
                                class: "flex flex-wrap items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 p-3"
                              }, [
                                _createElementVNode("span", _hoisted_38, [
                                  (tab.value === 'color' && colorHex(row.label))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "inline-block h-6 w-6 shrink-0 rounded-full border border-gray-400 shadow-sm",
                                        style: _normalizeStyle({
                      backgroundColor: colorHex(row.label) || undefined,
                    }),
                                        title: colorHex(row.label) || undefined,
                                        "aria-label": 'Couleur PrestaShop ' + colorHex(row.label)
                                      }, null, 12, _hoisted_39))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, _toDisplayString(row.label), 1),
                                  (row.sourceId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, "#" + _toDisplayString(row.sourceId), 1))
                                    : _createCommentVNode("", true),
                                  (tab.value === 'color' && colorHex(row.label))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(colorHex(row.label)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "rounded-lg border border-red-300 bg-white px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100",
                                  disabled: busy.value || loading.value,
                                  onClick: ($event: any) => (openPicker(row.label))
                                }, _toDisplayString(chooseLabel.value), 9, _hoisted_42)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _cache[53] || (_cache[53] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, " Correspondances enregistrées ", -1)),
                            (loading.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Chargement… "))
                              : (!mappings.value.length)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_45, " Aucune correspondance enregistrée. "))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mappings.value, (row) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: row.sourceLabelNormalized,
                                class: "flex flex-wrap items-center justify-between gap-3 rounded-lg border border-gray-200 p-3"
                              }, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("span", _hoisted_47, _toDisplayString(row.sourceLabel), 1),
                                  _cache[52] || (_cache[52] = _createElementVNode("span", { class: "mx-2 text-gray-400" }, "→", -1)),
                                  _createElementVNode("span", null, _toDisplayString(row.targetLabel || "#" + row.targetId), 1)
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "text-sm text-blue-700 hover:underline",
                                    disabled: busy.value || loading.value,
                                    onClick: ($event: any) => (openPicker(row.sourceLabel))
                                  }, " Modifier ", 8, _hoisted_49),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "text-sm text-red-700 hover:underline",
                                    disabled: busy.value,
                                    onClick: ($event: any) => (remove(row))
                                  }, " Supprimer ", 8, _hoisted_50)
                                ])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-xs text-gray-600 hover:underline",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (manualOpen.value = !manualOpen.value))
                            }, _toDisplayString(manualOpen.value
                    ? "Masquer l'ajout manuel"
                    : "Ajouter un libellé PrestaShop absent de cette liste"), 1),
                            (manualOpen.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((manualSource).value = $event)),
                                    type: "text",
                                    maxlength: "255",
                                    "aria-label": "Libellé PrestaShop",
                                    placeholder: "Libellé PrestaShop",
                                    class: "flex-1 min-w-[180px] rounded-lg border border-gray-300 px-3 py-2 text-sm"
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      manualSource.value,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "rounded-lg bg-gray-800 px-3 py-2 text-sm text-white disabled:opacity-50",
                                    disabled: !manualSource.value || busy.value || loading.value,
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (openPicker(manualSource.value)))
                                  }, " Choisir une valeur ", 8, _hoisted_53)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                ], 512)
              ], 512)
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    _createVNode(CouleursPickerModal, {
      isVisible: colorPickerVisible.value,
      "onUpdate:isVisible": _cache[13] || (_cache[13] = ($event: any) => ((colorPickerVisible).value = $event)),
      "couleurs-list": officialColors.value,
      "official-only": true,
      "selected-ids": [],
      onConfirm: onColorConfirm
    }, null, 8, ["isVisible", "couleurs-list"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (pickerVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
            _createElementVNode("button", {
              type: "button",
              class: "absolute inset-0 bg-black/50",
              "aria-label": "Fermer le choix",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (pickerVisible.value = false))
            }),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_57, _toDisplayString(chooseLabel.value), 1),
                  _createElementVNode("p", _hoisted_58, [
                    _cache[54] || (_cache[54] = _createTextVNode(" Valeur PrestaShop : ")),
                    _createElementVNode("strong", null, _toDisplayString(pickerSource.value), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Fermer",
                  class: "text-gray-500",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (pickerVisible.value = false))
                }, _cache[55] || (_cache[55] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))
              ]),
              (messageIsError.value && message.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true),
              (tab.value === 'category')
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createVNode(CategoryTreeAutocomplete, {
                      tree: categoriesTree.value,
                      "cat-id": "",
                      "sous-id": "",
                      "sous-sous-id": "",
                      label: "Catégorie eFashion",
                      placeholder: "Rechercher une catégorie feuille…",
                      onSelect: onCategorySelect
                    }, null, 8, ["tree"])
                  ]))
                : (tab.value === 'composition')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((pickerSearch).value = $event)),
                        type: "search",
                        "aria-label": "Rechercher une matière",
                        placeholder: "Rechercher une matière",
                        class: "rounded-lg border border-gray-300 px-3 py-2 text-sm"
                      }, null, 512), [
                        [
                          _vModelText,
                          pickerSearch.value,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTargets.value, (target) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: target.id,
                            type: "button",
                            class: "block w-full border-b border-gray-100 px-3 py-2 text-left text-sm hover:bg-green-50",
                            disabled: busy.value,
                            onClick: ($event: any) => (savePickedTarget(target.id))
                          }, _toDisplayString(target.label), 9, _hoisted_63))
                        }), 128)),
                        (!filteredTargets.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_64, " Aucune matière trouvée. "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (tab.value === 'brand')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "w-full px-3 py-2 text-left text-sm font-medium flex justify-between",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (brandListOpen.value = !brandListOpen.value))
                          }, [
                            _createTextVNode(" Choisir une marque existante (" + _toDisplayString(targets.value.length) + ") ", 1),
                            _cache[56] || (_cache[56] = _createElementVNode("i", { class: "fas fa-chevron-down text-xs" }, null, -1))
                          ]),
                          (brandListOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((pickerSearch).value = $event)),
                                  type: "search",
                                  "aria-label": "Rechercher une marque",
                                  placeholder: "Rechercher une marque",
                                  class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    pickerSearch.value,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createElementVNode("div", _hoisted_68, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTargets.value, (target) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: target.id,
                                      type: "button",
                                      class: "block w-full rounded-md px-3 py-2 text-left text-sm hover:bg-green-50",
                                      disabled: busy.value,
                                      onClick: ($event: any) => (savePickedTarget(target.id))
                                    }, [
                                      _createTextVNode(_toDisplayString(target.label) + " ", 1),
                                      _createElementVNode("span", _hoisted_70, "#" + _toDisplayString(target.id) + _toDisplayString(target.isDefault ? " · par défaut" : ""), 1)
                                    ], 8, _hoisted_69))
                                  }), 128)),
                                  (!filteredTargets.value.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_71, " Aucune marque trouvée. "))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "w-full px-3 py-2 text-left text-sm font-medium flex justify-between",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (brandCreateOpen.value = !brandCreateOpen.value))
                          }, _cache[57] || (_cache[57] = [
                            _createTextVNode(" Créer une nouvelle marque "),
                            _createElementVNode("i", { class: "fas fa-chevron-down text-xs" }, null, -1)
                          ])),
                          (brandCreateOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _cache[58] || (_cache[58] = _createElementVNode("label", {
                                  for: "prestashop-new-brand",
                                  class: "block text-xs text-gray-600"
                                }, "Nom de la nouvelle marque", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  id: "prestashop-new-brand",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((brandName).value = $event)),
                                  maxlength: "255",
                                  type: "text",
                                  class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    brandName.value,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "rounded-lg bg-green-600 px-3 py-2 text-sm text-white disabled:opacity-50",
                                  disabled: busy.value || !brandName.value,
                                  onClick: createBrand
                                }, " Créer et lier ", 8, _hoisted_74)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})